import { Skeleton } from "antd";
import "./index.scss";

function SkeletonCustom({ oneLine, children, loading = true, paragraph, rows = 1, ...rest }) {
  if (oneLine) {
    return (
      <Skeleton.Button
        active
        size={"small"}
        style={{
          width: "200px",
          height: "20px",
        }}
      />
    );
  }

  return (
    <Skeleton className="skeleton-custom" loading={loading} paragraph={paragraph || { rows: rows }} active {...rest}>
      {children}
    </Skeleton>
  );
}

export default SkeletonCustom;
